import { render, staticRenderFns } from "./Detail-Quotation.vue?vue&type=template&id=6d79e37e"
import script from "./Detail-Quotation.vue?vue&type=script&lang=js"
export * from "./Detail-Quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports